<template lang="pug">
  b-container
    b-row(class="justify-content-md-center")
      b-col.text-center(col md="12" lg="7")
        Message(
          :fontSizes="[40, 24]"
          title="Streamlined decision-making processes"
          subtitle="Our user-friendly software platform summarizes the data your teams need in a visual, interactive and pre-analyzed format. It helps executives stay up-to-date, gain time and avoid effort duplication."
        )
      b-col(cols="12" class="d-flex flex-column align-items-center")
        ProcessStep(v-for="(step, i) in steps" :key="i" :text="step.text" :icons="step.icons")

</template>

<script type="text/javascript">

import Message from '@/components/Shared/Message.vue'
import ProcessStep from '@/components/Home/ProcessStep.vue'

export default {
  name: 'Processes',
  components: {
    Message,
    ProcessStep
  },
  data () {
    return {
      steps: [
        {
          text: [
            'Documents in various formats disseminated throughout the organization',
            'User-friendly and interactive Single Source of Truth'
          ],
          icons: [
            'Icon Documents.svg',
            'Icon User-friendly.svg'
          ]
        },
        {
          text: [
            'Overflow of raw data requiring complex analysis to yield actionable insights',
            'Pre-analyzed summaries incorporating sector-specific knowledge'
          ],
          icons: [
            'Icon Raw Data.svg',
            'Icon Analyse.svg'
          ]
        },
        {
          text: [
            'Reliance on personal recollection of anecdotal facts',
            'Comprehensive fact base at your execs’ fingertips'
          ],
          icons: [
            'Icon Reliance.svg',
            'Icon Fact Base.svg'
          ]
        },
        {
          text: [
            'Ad hoc investments in consulting and market research producing static one-off reports',
            'Continuously updated software platform'
          ],
          icons: [
            'Icon Ad hoc.svg',
            'Icon Software.svg'
          ]
        },
        {
          text: [
            'Duplication of effort across teams and over time',
            'Memorialized collective knowledge base'
          ],
          icons: [
            'Icon Duplication.svg',
            'Icon Knowledge Base.svg'
          ]
        }
      ]
    }
  }
}
</script>


<style scoped lang="scss">
$color-title: #364149;
$color-subtitle: #767F86;
</style>